/* 
  Quick JS by Jason @ freakdesign.
  Questions? Ping me on twitter: @freakdesign

  Relates to blog post:
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page

  Example:
  https://jasons-experiments.myshopify.com/products/alex-twill-pant-mariner

*/
(function () {
  "use strict";
  /* In case you want to output a bunch of things to the debug console */
  var debug = true;
  var cartCookie;

  /* A console logging function */
  var clog = function (a) {
    if (!debug) {
      return;
    }
    console.log(a);
  };

  /* get cookie by name */
  var getCookie = function (name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  };

  var toggleCalcButton = function (isTrigger) {
    if (isTrigger) {
      $('button[data-cartshipping-submit]').text('Calculating...');
      $('button[data-cartshipping-submit]').attr('disabled', true);
    }
    else {
      $('button[data-cartshipping-submit]').text('Calculate Shipping');
      $('button[data-cartshipping-submit]').attr('disabled', false);
    }
    
  }

  /* update the cart cookie value */
  var updateCartCookie = function (a) {
    clog("changing cart cookie value to: " + a);
    var date = new Date();
    date.setTime(date.getTime() + 14 * 86400000);
    var expires = "; expires=" + date.toGMTString();
    document.cookie = "cart=" + a + expires + "; path=/";
  };

  /* reset the cart cookie value */
  var resetCartCookie = function () {
    updateCartCookie(cartCookie);
    clog(getCookie("cart"));
  };

  /* get the rates */
  var getRates = function () {
    var selectedQty = document.querySelector("[data-quantity-select]").value; // product selected quantity
    var prodId = $("#mainPrdId").val(); // we need the product variant id

    var addData = {
      id: parseInt(prodId),
      quantity: parseInt(selectedQty),
    };

    fetch("/cart/add.js", {
      body: JSON.stringify(addData),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With":
          "xmlhttprequest" /* XMLHttpRequest is ok too, it's case insensitive */,
      },
      method: "POST",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {

        $.ajax({
          type: "GET",
          url: "/cart/shipping_rates.json",
          data: {
            "shipping_address[country]": $('#address_country').val(),
            "shipping_address[province]": $('#address_province').val(),
            "shipping_address[city]": $('#address_city').val(),
            "shipping_address[zip]": $('#address_zip').val(),
          },
          success: function (d) {
            shippingMessage.innerHTML = '';
            if (d.shipping_rates && d.shipping_rates.length) {
              // shippingMessage.innerHTML = "We found " + d.shipping_rates.length + " shipping rates available for "+$('#address_zip').val()+", "+$('#address_city').val()+", "+$('#address_province').val()+", "+$('#address_country').val()+", starting at $"+d.shipping_rates[0].price+".<br><br>";
              $(d.shipping_rates).each(function(key, rates){
                if (rates.price == 0) {
                  rates.price = 'FREE';
                }
                else {
                  rates.price = "$"+rates.price;
                }
                shippingMessage.innerHTML += '<div>' + rates.name + " - <span class='pull-right' style='color: red;'>" + rates.price + "</span></div>";
              });
              $('.cart-shippingcalc-response').addClass('visible');
            }
            resetCartCookie();
            toggleCalcButton(false);
          },
          error: function (err) {
            shippingMessage.innerHTML = err.responseText;
            $('.cart-shippingcalc-response').addClass('visible');
            toggleCalcButton(false);
            resetCartCookie();
          },
          dataType: "json",
        });
      })
      .catch(function (err) {
        /* uh oh, we have error. */
        console.error(err);
        toggleCalcButton(false);
        resetCartCookie();
      });
  };

  /* The ID of the element that you want to add the shipping fields into */
  var productSection = document.getElementsByClassName("cart-shipping");
  if (!productSection.length) {
    clog("Could not find the element");
    return;
  }

  /* create a message box */
  var shippingMessage = document.createElement("p");

  var initFields = function () {

    /* create the province state picker */

    var provinces = [
      "Australian Capital Territory",
      "New South Wales",
      "Northern Territory",
      "Queensland",
      "South Australia",
      "Tasmania",
      "Victoria",
      "Western Australia"
    ];
    for (var i = 0; i < provinces.length; i++) {
      $('#address_province').append($('<option>', {
          value: provinces[i],
          text: provinces[i]
      }));
    }
    /* create a wrapper for the fields */
    var shippingCalcWrapper = document.createElement("div");
    shippingCalcWrapper.className = "cart-shippingcalc-response";
    shippingCalcWrapper.style = "background-color: #f6f6f6; padding: 5px 5px 5px 15px; font-size: 13px;";


    $('button[data-cartshipping-submit]').on('click', function(){
      
      if ($('#address_city').val() == '') {
        shippingMessage.innerHTML = 'Enter Suburb';
        $('.cart-shippingcalc-response').addClass('visible');
        return;
      }
      
      toggleCalcButton(true);
      
      cartCookie = getCookie("cart");
      var tempCookieValue =
        tempCookieValue || "temp-cart-cookie___" + Date.now();
      var fakeCookieValue =
        fakeCookieValue || "fake-cart-cookie___" + Date.now();

      /* if not found, make a new temp cookie */
      if (!cartCookie) {
        clog("no cookie found");
        updateCartCookie(tempCookieValue);
        cartCookie = getCookie("cart");
      } else {
        clog("cookie found");
      }

      /* if found but has a weird length, bail */
      if (cartCookie.length < 32) {
        clog("cart ID not valid");
        return;
      }

      /* Change the cookie value to a new 32 character value */
      updateCartCookie(fakeCookieValue);
      clog(getCookie("cart"));

      getRates();
      return false;
    });


    shippingCalcWrapper.appendChild(shippingMessage);

    /* add to the page */
    productSection[0].appendChild(shippingCalcWrapper);
  };

  initFields();
})();
